import t from "react";
const n = t.createContext(null), s = () => {
  const e = t.useContext(n);
  if (e == null)
    throw new Error(
      "Header components must be wrapped in either <ODSStandarGlobalHeader />, <ODSSlimGlobalHeader /> or <ODSSubtleGlobalHeader />"
    );
  return e;
};
function a() {
  const [e, r] = t.useState(
    typeof window < "u" ? window.scrollY : 0
  );
  return t.useEffect(() => {
    const o = () => r(window.scrollY);
    return window.addEventListener("scroll", o, { passive: !0 }), () => window.removeEventListener("scroll", o);
  }, []), e;
}
export {
  n as H,
  a,
  s as u
};
//# sourceMappingURL=ODSGlobalHeader.utils.CBEpEpr3.js.map
